// -- State Feedback & Pole Placement -- Control Systems ---------------------------

const S = {
  wrapper:      { marginTop:'10px', padding:'40px', border:'3px solid grey', fontFamily:"'Georgia', serif", color:'#1a1a2e', lineHeight:'1.7' },
  h1:           { fontSize:'2rem', fontWeight:'700', borderBottom:'3px solid #c0392b', paddingBottom:'8px', marginBottom:'24px', color:'#7B0D0D' },
  h2:           { fontSize:'1.3rem', fontWeight:'700', color:'#c0392b', marginTop:'36px', marginBottom:'12px', borderLeft:'4px solid #c0392b', paddingLeft:'10px' },
  p:            { marginBottom:'12px', fontSize:'0.97rem' },
  infoBox:      { background:'#FEF0F0', border:'2px solid #c0392b', borderRadius:'6px', padding:'16px 20px', margin:'16px 0' },
  infoBoxTitle: { fontWeight:'700', fontFamily:"'Courier New', monospace", fontSize:'0.88rem', color:'#7B0D0D', marginBottom:'8px' },
  infoBoxItem:  { fontSize:'0.9rem', margin:'4px 0', paddingLeft:'12px', borderLeft:'2px solid #c0392b' },
  table:        { width:'100%', borderCollapse:'collapse', marginBottom:'20px', fontSize:'0.92rem' },
  th:           { background:'#c0392b', color:'#fff', padding:'10px 14px', textAlign:'left', fontWeight:'700', fontSize:'0.9rem' },
  tdE:          { padding:'10px 14px', borderBottom:'1px solid #f0cece', verticalAlign:'top', background:'#fff5f5' },
  tdO:          { padding:'10px 14px', borderBottom:'1px solid #f0cece', verticalAlign:'top', background:'#fff' },
  tdL:          { fontWeight:'600', color:'#7B0D0D', whiteSpace:'nowrap', width:'220px' },
  code:         { fontFamily:"'Courier New', monospace", fontSize:'0.88rem', whiteSpace:'pre-wrap' },
  dWrap:        { margin:'24px 0', background:'#fffafa', border:'1px solid #f0cece', borderRadius:'8px', padding:'20px' },
  dTitle:       { fontWeight:'700', fontSize:'0.95rem', color:'#7B0D0D', marginBottom:'12px', textAlign:'center', letterSpacing:'0.02em' },
  dCaption:     { fontSize:'0.84rem', color:'#555', textAlign:'center', marginTop:'10px', fontStyle:'italic' },
};

function InfoBox({ title, items }) {
  return (
    <div style={S.infoBox}>
      <div style={S.infoBoxTitle}>{title}</div>
      {items.map((item, i) => <div key={i} style={S.infoBoxItem}>{item}</div>)}
    </div>
  );
}

function Table2({ rows }) {
  return (
    <table style={S.table}>
      <thead><tr>
        <th style={{ ...S.th, width:'220px' }}>Concept</th>
        <th style={S.th}>Explanation / Formula</th>
      </tr></thead>
      <tbody>
        {rows.map(([label, content], i) => (
          <tr key={i}>
            <td style={{ ...(i%2===0?S.tdE:S.tdO), ...S.tdL }}>{label}</td>
            <td style={{ ...(i%2===0?S.tdE:S.tdO), ...S.code }}>{content}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

// -- Palette --
const RED    = '#c0392b';
const DKRED  = '#7B0D0D';
const BLUE   = '#2E75B6';
const ORANGE = '#e07b00';
const GREEN  = '#27ae60';
const PURPLE = '#8e44ad';
const TEAL   = '#16a085';
const LTRED  = '#fff5f5';
const LTBLU  = '#eaf3ff';
const LTORG  = '#fff7e6';
const LTGRN  = '#f0fef4';
const LTPUR  = '#f5eeff';
const LTTEAL = '#e8faf5';
const BORDER = '#f0cece';

// -- SVG Defs --
function Defs() {
  return (
    <defs>
      <marker id="aRed"    markerWidth="8" markerHeight="8" refX="6" refY="4" orient="auto"><polygon points="0 0,7 4,0 8" fill={RED}/></marker>
      <marker id="aBlue"   markerWidth="8" markerHeight="8" refX="6" refY="4" orient="auto"><polygon points="0 0,7 4,0 8" fill={BLUE}/></marker>
      <marker id="aOrange" markerWidth="8" markerHeight="8" refX="6" refY="4" orient="auto"><polygon points="0 0,7 4,0 8" fill={ORANGE}/></marker>
      <marker id="aGreen"  markerWidth="8" markerHeight="8" refX="6" refY="4" orient="auto"><polygon points="0 0,7 4,0 8" fill={GREEN}/></marker>
      <marker id="aPurple" markerWidth="8" markerHeight="8" refX="6" refY="4" orient="auto"><polygon points="0 0,7 4,0 8" fill={PURPLE}/></marker>
      <marker id="aTeal"   markerWidth="8" markerHeight="8" refX="6" refY="4" orient="auto"><polygon points="0 0,7 4,0 8" fill={TEAL}/></marker>
      <marker id="aGray"   markerWidth="8" markerHeight="8" refX="6" refY="4" orient="auto"><polygon points="0 0,7 4,0 8" fill="#888"/></marker>
    </defs>
  );
}

// -- Block helper --
function Blk({ x, y, w, h, fill, stroke, label, sub, fs=12 }) {
  return (
    <g>
      <rect x={x} y={y} width={w} height={h} rx={5} fill={fill} stroke={stroke} strokeWidth="1.5"/>
      <text x={x+w/2} y={y+h/2+(sub?-5:5)} textAnchor="middle" fontSize={fs} fill={stroke} fontWeight="700">{label}</text>
      {sub && <text x={x+w/2} y={y+h/2+11} textAnchor="middle" fontSize="9" fill={stroke} opacity="0.85">{sub}</text>}
    </g>
  );
}

// -- Arrow helper --
function Arr({ x1, y1, x2, y2, color=RED, marker='aRed', dash=false, lbl='', lx, ly }) {
  return (
    <g>
      <line x1={x1} y1={y1} x2={x2} y2={y2} stroke={color} strokeWidth="1.8"
        strokeDasharray={dash?'5 3':'none'} markerEnd={'url(#'+marker+')'}/>
      {lbl && (
        <text x={lx||((x1+x2)/2)} y={ly||((y1+y2)/2-5)}
          textAnchor="middle" fontSize="10" fill={color} fontWeight="600">{lbl}</text>
      )}
    </g>
  );
}

// -- Info card helper --
function Card({ x, y, w, h, bg, bc, lines }) {
  return (
    <g>
      <rect x={x} y={y} width={w} height={h} rx={3} fill={bg} stroke={bc} strokeWidth="1"/>
      {lines.map((t, i) => (
        <text key={i} x={x+8} y={y+16+i*15}
          fontSize={i===0?'11':'10'} fill={i===0?bc:'#444'} fontWeight={i===0?'700':'400'}>{t}</text>
      ))}
    </g>
  );
}

// =================================================================
// Diagram 1 -- Closed-Loop State Feedback Block Diagram
// =================================================================
function DiagramBlockDiagram() {
  const W = 900, H = 320;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Full-State Feedback Block Diagram: u = -Kx + Nr</div>
      <svg viewBox={'0 0 ' + W + ' ' + H} style={{ width:'100%', display:'block' }}>
        <Defs/>

        {/* Reference input */}
        <Arr x1={14} y1={110} x2={58} y2={110} color={RED} marker="aRed"/>
        <text x={8} y={104} fontSize="13" fill={RED} fontWeight="700">r</text>

        {/* Pre-filter N */}
        <Blk x={58} y={90} w={60} h={40} fill={LTPUR} stroke={PURPLE} label="N" sub="pre-filter"/>
        <Arr x1={118} y1={110} x2={152} y2={110} color={PURPLE} marker="aPurple"/>

        {/* Summing junction */}
        <circle cx={170} cy={110} r={18} fill="#fff" stroke={RED} strokeWidth="1.8"/>
        <text x={170} y={116} textAnchor="middle" fontSize="17" fill={RED} fontWeight="700">+</text>
        <text x={159} y={98} fontSize="10" fill={RED}>+</text>
        <text x={159} y={124} fontSize="10" fill={RED}>-</text>

        {/* Plant */}
        <Arr x1={188} y1={110} x2={238} y2={110} color={RED} marker="aRed" lbl="u" lx={213} ly={102}/>
        <Blk x={238} y={84} w={140} h={52} fill={LTBLU} stroke={BLUE} label="PLANT" sub="x_dot = Ax + Bu"/>

        {/* State x out of plant */}
        <Arr x1={378} y1={110} x2={480} y2={110} color={BLUE} marker="aBlue"/>
        <circle cx={430} cy={110} r={5} fill={BLUE}/>
        <text x={400} y={103} fontSize="12" fill={BLUE} fontWeight="700">x(t)</text>

        {/* Output via C */}
        <Blk x={480} y={84} w={80} h={52} fill={LTGRN} stroke={GREEN} label="C" sub="output map"/>
        <Arr x1={560} y1={110} x2={640} y2={110} color={GREEN} marker="aGreen"/>
        <text x={645} y={114} fontSize="13" fill={GREEN} fontWeight="700">y(t)</text>

        {/* Gain K (feedback path) */}
        <Blk x={266} y={210} w={120} h={44} fill={LTRED} stroke={RED} label="-K" sub="gain matrix (1 x n)"/>

        {/* State down to K */}
        <line x1={430} y1={110} x2={430} y2={232} stroke={RED} strokeWidth="1.8"/>
        <Arr x1={430} y1={232} x2={386} y2={232} color={RED} marker="aRed"/>
        {/* K back to summer */}
        <line x1={266} y1={232} x2={170} y2={232} stroke={RED} strokeWidth="1.8"/>
        <Arr x1={170} y1={232} x2={170} y2={128} color={RED} marker="aRed"/>
        <text x={154} y={185} fontSize="10" fill={RED} fontWeight="600">-Kx</text>

        {/* Closed-loop annotation box */}
        <rect x={20} y={264} width={420} height={44} rx={4} fill={LTRED} stroke={RED} strokeWidth="1"/>
        <text x={28} y={281} fontSize="11" fill={RED} fontWeight="700">Closed-loop: x_dot = (A - BK)x + BNr</text>
        <text x={28} y={298} fontSize="10" fill="#444">Eigenvalues of (A - BK) = chosen closed-loop poles</text>

        {/* Design goal box */}
        <rect x={456} y={264} width={428} height={44} rx={4} fill={LTBLU} stroke={BLUE} strokeWidth="1"/>
        <text x={464} y={281} fontSize="11" fill={BLUE} fontWeight="700">Design task: choose K so eig(A - BK) = desired poles</text>
        <text x={464} y={298} fontSize="10" fill="#444">Possible for any desired poles if (A, B) is controllable</text>

        {/* Legend */}
        {[
          { x:700, y:58,  bg:LTPUR, bc:PURPLE, label:'N', desc:'Pre-filter: DC gain correction' },
          { x:700, y:94,  bg:LTRED, bc:RED,    label:'K', desc:'State feedback gain (1xn or pxn)' },
          { x:700, y:130, bg:LTBLU, bc:BLUE,   label:'A,B', desc:'Plant state & input matrices' },
          { x:700, y:166, bg:LTGRN, bc:GREEN,  label:'C', desc:'Output matrix (sensor map)' },
        ].map(({ x, y, bg, bc, label, desc }) => (
          <g key={y}>
            <rect x={x} y={y} width={188} height={32} rx={3} fill={bg} stroke={bc} strokeWidth="1"/>
            <text x={x+8} y={y+13} fontSize="11" fill={bc} fontWeight="700">{label}:</text>
            <text x={x+8} y={y+27} fontSize="9.5" fill="#444">{desc}</text>
          </g>
        ))}
      </svg>
      <div style={S.dCaption}>
        Full-state feedback replaces the open-loop input with u(t) = -Kx(t) + Nr(t), where K is the gain matrix and N is a scalar pre-filter that corrects the steady-state DC gain. The plant dynamics become x_dot = (A-BK)x + BNr -- the closed-loop system matrix is A-BK. By choosing K, the designer moves all n closed-loop eigenvalues to any desired locations in the s-plane, provided the system is controllable.
      </div>
    </div>
  );
}

// =================================================================
// Diagram 2 -- S-plane: open-loop vs closed-loop pole placement
// =================================================================
function DiagramSPlane() {
  const W = 900, H = 400;
  const px = 60, py = 20, pw = 480, ph = 360;
  const xR = [-6, 2], yR = [-4, 4];
  const toX = r => px + (r - xR[0]) / (xR[1] - xR[0]) * pw;
  const toY = i => py + (1 - (i - yR[0]) / (yR[1] - yR[0])) * ph;
  const ox = toX(0), oy = toY(0);

  // Open-loop poles: unstable & slow
  const olPoles = [
    { s:[0.5, 0],   label:'OL: s=+0.5',  side:'right' },
    { s:[-0.3, 1.2],label:'OL: s=-0.3+j1.2', side:'left' },
    { s:[-0.3,-1.2],label:null, side:'left' },
    { s:[-2.5, 0],  label:'OL: s=-2.5',  side:'left' },
  ];

  // Closed-loop desired poles: stable, good damping
  const clPoles = [
    { s:[-2, 2],   label:'CL: s=-2+j2',   side:'left' },
    { s:[-2,-2],   label:null, side:'left' },
    { s:[-4, 0],   label:'CL: s=-4',       side:'left' },
    { s:[-3, 0],   label:'CL: s=-3',       side:'left' },
  ];

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Pole Placement in the s-Plane -- Open-Loop vs Desired Closed-Loop</div>
      <svg viewBox={'0 0 ' + W + ' ' + H} style={{ width:'100%', display:'block' }}>
        <Defs/>

        {/* Plot area */}
        <rect x={px} y={py} width={pw} height={ph} rx={4} fill="#fff" stroke={BORDER}/>
        <rect x={ox} y={py} width={px+pw-ox} height={ph} fill="#ffebee" opacity="0.3"/>
        <text x={ox+70} y={py+22} textAnchor="middle" fontSize="12" fill={RED} fontWeight="700" opacity="0.55">UNSTABLE</text>
        <text x={ox-90} y={py+22} textAnchor="middle" fontSize="12" fill={GREEN} fontWeight="700" opacity="0.55">STABLE</text>

        {/* Grid */}
        {[-5,-4,-3,-2,-1,0,1].map(v => (
          <g key={'gx'+v}>
            <line x1={toX(v)} y1={py} x2={toX(v)} y2={py+ph} stroke="#f5f0f0" strokeWidth="1"/>
            {v!==0 && <text x={toX(v)} y={py+ph+14} textAnchor="middle" fontSize="10" fill="#ccc">{v}</text>}
          </g>
        ))}
        {[-3,-2,-1,1,2,3].map(v => (
          <g key={'gy'+v}>
            <line x1={px} y1={toY(v)} x2={px+pw} y2={toY(v)} stroke="#f5f0f0" strokeWidth="1"/>
            <text x={px-6} y={toY(v)+4} textAnchor="end" fontSize="10" fill="#ccc">{v>0?'+'+v+'j':v+'j'}</text>
          </g>
        ))}

        {/* Axes */}
        <line x1={px} y1={oy} x2={px+pw} y2={oy} stroke="#ccc" strokeWidth="1.4"/>
        <line x1={ox} y1={py} x2={ox} y2={py+ph} stroke={RED} strokeWidth="1.8" strokeDasharray="6 3" opacity="0.5"/>
        <text x={px+pw+6} y={oy+4} fontSize="11" fill="#888">sigma</text>
        <text x={ox+4} y={py+12} fontSize="11" fill="#888">j*omega</text>

        {/* Desired region: zeta>0.5, sigma < -1 */}
        {(() => {
          const ang = Math.acos(0.5);
          return (
            <>
              <line x1={ox} y1={oy} x2={toX(-4.5*Math.cos(ang))} y2={toY(4.5*Math.sin(ang))}
                stroke="#27ae60" strokeWidth="1.2" strokeDasharray="5 3" opacity="0.5"/>
              <line x1={ox} y1={oy} x2={toX(-4.5*Math.cos(ang))} y2={toY(-4.5*Math.sin(ang))}
                stroke="#27ae60" strokeWidth="1.2" strokeDasharray="5 3" opacity="0.5"/>
              <text x={toX(-3.5*Math.cos(ang))-10} y={toY(3.5*Math.sin(ang))-6}
                fontSize="9" fill={GREEN} opacity="0.8">zeta=0.5</text>
            </>
          );
        })()}
        <line x1={toX(-1)} y1={py} x2={toX(-1)} y2={py+ph}
          stroke={ORANGE} strokeWidth="1.2" strokeDasharray="5 3" opacity="0.5"/>
        <text x={toX(-1)+3} y={py+14} fontSize="9" fill={ORANGE}>sigma=-1</text>

        {/* Desired region shading */}
        <polygon
          points={[
            toX(-1)+','+py,
            toX(-6)+','+py,
            toX(-6)+','+(py+ph),
            toX(-1)+','+(py+ph),
          ].join(' ')}
          fill={GREEN} opacity="0.04"/>

        {/* Open-loop poles */}
        {olPoles.map(({ s, label }, i) => (
          <g key={'ol'+i}>
            <text x={toX(s[0])} y={toY(s[1])+5} textAnchor="middle" fontSize="18"
              fill={ORANGE} fontWeight="700">x</text>
            {label && (
              <text x={toX(s[0])+(s[0]>0?12:-12)} y={toY(s[1])-10}
                textAnchor={s[0]>0?'start':'end'} fontSize="9.5" fill={ORANGE} fontWeight="700">{label}</text>
            )}
          </g>
        ))}

        {/* Closed-loop poles */}
        {clPoles.map(({ s, label }, i) => (
          <g key={'cl'+i}>
            <circle cx={toX(s[0])} cy={toY(s[1])} r={7} fill={BLUE} opacity="0.85"/>
            {label && (
              <text x={toX(s[0])-12} y={toY(s[1])+(s[1]>0?-10:14)}
                textAnchor="end" fontSize="9.5" fill={BLUE} fontWeight="700">{label}</text>
            )}
          </g>
        ))}

        {/* Movement arrows */}
        {[
          [[0.5,0],[-3,0]],
          [[-0.3,1.2],[-2,2]],
          [[-0.3,-1.2],[-2,-2]],
        ].map(([[r1,i1],[r2,i2]], idx) => (
          <Arr key={'mv'+idx}
            x1={toX(r1)} y1={toY(i1)} x2={toX(r2)} y2={toY(i2)}
            color={GREEN} marker="aGreen" dash={true}/>
        ))}

        {/* Legend text */}
        <text x={px+10} y={py+ph-10} fontSize="10" fill={ORANGE} fontWeight="700">x  Open-loop poles (gain K=0)</text>
        <circle cx={px+174} cy={py+ph-14} r={6} fill={BLUE} opacity="0.8"/>
        <text x={px+184} y={py+ph-10} fontSize="10" fill={BLUE} fontWeight="700">Desired closed-loop poles</text>
        <line x1={px+310} y1={py+ph-14} x2={px+340} y2={py+ph-14} stroke={GREEN} strokeWidth="1.5" strokeDasharray="4 2"/>
        <text x={px+344} y={py+ph-10} fontSize="10" fill={GREEN} fontWeight="700">K moves pole here</text>

        {/* Right info panel */}
        <rect x={560} y={py} width={328} height={ph} rx={5} fill="#fff" stroke={BORDER}/>
        <text x={724} y={py+18} textAnchor="middle" fontSize="13" fill={DKRED} fontWeight="700">Pole Placement Design Goals</text>

        {[
          { y:py+26,  bg:LTRED, bc:RED,    lines:['Stability requirement','ALL poles must be in LHP (Re(s) &lt; 0)','Poles in RHP: unstable; on axis: marginal'] },
          { y:py+86,  bg:LTGRN, bc:GREEN,  lines:['Damping requirement','zeta = |Re(s)| / |s|  (angle from Im-axis)','Typical: zeta &gt;= 0.5 (PM &gt;= 45 deg)'] },
          { y:py+146, bg:LTBLU, bc:BLUE,   lines:['Speed requirement','Faster = poles further left (larger |Re(s)|)','ts approx 4 / |Re(dominant pole)|'] },
          { y:py+206, bg:LTORG, bc:ORANGE, lines:['Non-dominant poles','Place 3-5x further left than dominant pair','Their transient decays fast  --  negligible effect'] },
          { y:py+266, bg:LTPUR, bc:PURPLE, lines:['Key theorem','Any desired poles achievable if (A,B) is controllable','Eigenvalues of A-BK can be placed anywhere'] },
        ].map(({ y, bg, bc, lines }) => (
          <Card key={y} x={566} y={y} w={316} h={56} bg={bg} bc={bc} lines={lines}/>
        ))}
      </svg>
      <div style={S.dCaption}>
        The state feedback gain K shifts closed-loop poles from their open-loop positions (marked x) to desired locations (filled circles). The unstable open-loop pole at s=+0.5 is moved deep into the left-half plane. The design region (shaded) satisfies damping zeta &gt;= 0.5 and minimum decay sigma &gt;= 1. All four poles are placed simultaneously by choosing the single gain vector K.
      </div>
    </div>
  );
}

// =================================================================
// Diagram 3 -- Step response comparison: different pole locations
// =================================================================
function DiagramStepResponse() {
  const W = 900, H = 360;
  const bx = 60, by = 30, bw = 560, bh = 290;
  const tMax = 5.0;
  const toX = t => bx + (t/tMax)*bw;
  const toY = v => by + bh - Math.min(Math.max(v, -0.2), 1.8) * bh * 0.72;

  // Second-order step responses: y(t) for different pole configs
  const configs = [
    {
      label:'Overdamped (zeta=1.5)',
      color:TEAL, poles:'s=-1, s=-2',
      // y(t) = 1 - 2*e^(-t) + e^(-2t) style
      pts: Array.from({length:80}, (_,k) => {
        const t = k * tMax/79;
        return [t, 1 - 1.5*Math.exp(-1.5*t) + 0.5*Math.exp(-2.5*t)];
      }),
    },
    {
      label:'Well-damped (zeta=0.7)',
      color:GREEN, poles:'s=-2+/-j2',
      pts: Array.from({length:80}, (_,k) => {
        const t = k * tMax/79;
        const s = 0.7, wn = 2.8;
        const wd = wn * Math.sqrt(1 - s*s);
        return [t, 1 - Math.exp(-s*wn*t) * (Math.cos(wd*t) + (s/Math.sqrt(1-s*s))*Math.sin(wd*t))];
      }),
    },
    {
      label:'Lightly damped (zeta=0.3)',
      color:ORANGE, poles:'s=-1+/-j3',
      pts: Array.from({length:80}, (_,k) => {
        const t = k * tMax/79;
        const s = 0.3, wn = 3.16;
        const wd = wn * Math.sqrt(1 - s*s);
        return [t, 1 - Math.exp(-s*wn*t) * (Math.cos(wd*t) + (s/Math.sqrt(1-s*s))*Math.sin(wd*t))];
      }),
    },
    {
      label:'Too slow (zeta=0.7, slow)',
      color:BLUE, poles:'s=-0.5+/-j0.7',
      pts: Array.from({length:80}, (_,k) => {
        const t = k * tMax/79;
        const s = 0.7, wn = 0.87;
        const wd = wn * Math.sqrt(1 - s*s);
        return [t, 1 - Math.exp(-s*wn*t) * (Math.cos(wd*t) + (s/Math.sqrt(1-s*s))*Math.sin(wd*t))];
      }),
    },
    {
      label:'Ideal target (zeta=0.7, fast)',
      color:RED, poles:'s=-3+/-j3',
      pts: Array.from({length:80}, (_,k) => {
        const t = k * tMax/79;
        const s = 0.7, wn = 4.24;
        const wd = wn * Math.sqrt(1 - s*s);
        return [t, 1 - Math.exp(-s*wn*t) * (Math.cos(wd*t) + (s/Math.sqrt(1-s*s))*Math.sin(wd*t))];
      }),
    },
  ];

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Step Responses for Different Pole Placements</div>
      <svg viewBox={'0 0 ' + W + ' ' + H} style={{ width:'100%', display:'block' }}>
        <Defs/>

        {/* Plot area */}
        <rect x={bx} y={by} width={bw} height={bh} rx={4} fill="#fff" stroke={BORDER}/>

        {/* Grid */}
        {[0,0.25,0.5,0.75,1.0,1.25,1.5].map(v => (
          <g key={'hg'+v}>
            <line x1={bx} y1={toY(v)} x2={bx+bw} y2={toY(v)} stroke="#f5f0f0" strokeWidth="1"/>
            <text x={bx-6} y={toY(v)+4} textAnchor="end" fontSize="10" fill="#bbb">{v}</text>
          </g>
        ))}
        {[0,1,2,3,4,5].map(t => (
          <line key={'vg'+t} x1={toX(t)} y1={by} x2={toX(t)} y2={by+bh} stroke="#f5f0f0" strokeWidth="1"/>
        ))}
        {[1,2,3,4,5].map(t => (
          <text key={'vt'+t} x={toX(t)} y={by+bh+14} textAnchor="middle" fontSize="10" fill="#bbb">{t}</text>
        ))}

        {/* Reference line */}
        <line x1={bx} y1={toY(1)} x2={bx+bw} y2={toY(1)} stroke="#bbb" strokeWidth="1.5" strokeDasharray="5 3"/>
        <text x={bx+bw-4} y={toY(1)-5} textAnchor="end" fontSize="10" fill="#999">reference = 1</text>

        {/* Axes */}
        <line x1={bx} y1={by+bh} x2={bx+bw} y2={by+bh} stroke="#aaa" strokeWidth="1.3"/>
        <line x1={bx} y1={by} x2={bx} y2={by+bh} stroke="#aaa" strokeWidth="1.3"/>
        <text x={bx+bw/2} y={by+bh+26} textAnchor="middle" fontSize="11" fill="#777">Time (seconds)</text>
        <text x={bx-36} y={by+bh/2} textAnchor="middle" fontSize="11" fill="#777"
          transform={'rotate(-90,'+( bx-36)+','+(by+bh/2)+')'}>y(t)</text>

        {/* Curves */}
        {configs.map(({ label, color, pts }) => (
          <polyline key={label}
            points={pts.map(([t,v]) => toX(t)+','+toY(v)).join(' ')}
            fill="none" stroke={color} strokeWidth="2.2"/>
        ))}

        {/* Legend in plot */}
        {configs.map(({ label, color, poles }, i) => (
          <g key={'leg'+i}>
            <line x1={bx+bw-350} y1={by+18+i*26} x2={bx+bw-322} y2={by+18+i*26} stroke={color} strokeWidth="2.5"/>
            <text x={bx+bw-318} y={by+22+i*26} fontSize="10" fill={color} fontWeight="700">{label}</text>
          </g>
        ))}

        {/* Right panel */}
        <rect x={640} y={by} width={248} height={bh} rx={5} fill="#fff" stroke={BORDER}/>
        <text x={764} y={by+16} textAnchor="middle" fontSize="12" fill={DKRED} fontWeight="700">Reading the Response</text>

        {[
          { y:by+24, bg:LTTEAL, bc:TEAL,   lines:['Overdamped','No overshoot, slowest to settle','All real poles; zeta &gt; 1'] },
          { y:by+82, bg:LTGRN,  bc:GREEN,  lines:['Well-damped','~5% overshoot, fast settle','zeta=0.7: recommended range'] },
          { y:by+140, bg:LTORG, bc:ORANGE, lines:['Lightly damped','Large overshoot, long ringing','zeta=0.3: often unacceptable'] },
          { y:by+198, bg:LTBLU, bc:BLUE,   lines:['Too slow','Good damping but takes too long','Poles too close to origin'] },
          { y:by+256, bg:LTRED, bc:RED,    lines:['Ideal target','Fast + well-damped','zeta=0.7, wn=4.24: use this K'] },
        ].map(({ y, bg, bc, lines }) => (
          <Card key={y} x={646} y={y} w={236} h={54} bg={bg} bc={bc} lines={lines}/>
        ))}
      </svg>
      <div style={S.dCaption}>
        Different pole placements produce dramatically different step responses. The red curve (ideal target: poles at s=-3+/-j3) achieves both fast rise and low overshoot. Moving poles left speeds up the response; increasing damping angle (toward the real axis) reduces overshoot. Pole placement gives the designer direct, simultaneous control over all these characteristics -- rather than tuning one parameter at a time.
      </div>
    </div>
  );
}

// =================================================================
// Diagram 4 -- Ackermann's Formula step-by-step
// =================================================================
function DiagramAckermann() {
  const W = 900, H = 390;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Ackermann's Formula -- Step-by-Step Derivation (SISO)</div>
      <svg viewBox={'0 0 ' + W + ' ' + H} style={{ width:'100%', display:'block' }}>
        <Defs/>

        {/* Steps banner */}
        {[
          { x:10,  w:168, num:'1', title:'Desired char. poly', color:BLUE,   bg:LTBLU },
          { x:186, w:168, num:'2', title:'Controllability matrix C', color:GREEN, bg:LTGRN },
          { x:362, w:168, num:'3', title:'Evaluate phi(A)', color:PURPLE, bg:LTPUR },
          { x:538, w:168, num:'4', title:'Apply Ackermann', color:RED,   bg:LTRED },
          { x:714, w:172, num:'5', title:'Verify & simulate', color:ORANGE, bg:LTORG },
        ].map(({ x, w, num, title, color, bg }) => (
          <g key={x}>
            <rect x={x} y={10} width={w} height={44} rx={4} fill={bg} stroke={color} strokeWidth="1.5"/>
            <circle cx={x+18} cy={32} r={12} fill={color}/>
            <text x={x+18} y={36} textAnchor="middle" fontSize="12" fill="#fff" fontWeight="700">{num}</text>
            <text x={x+34} y={28} fontSize="11" fill={color} fontWeight="700">{title}</text>
          </g>
        ))}

        {/* Step arrows */}
        {[176,352,528,704].map(x => (
          <Arr key={'sa'+x} x1={x} y1={32} x2={x+10} y2={32} color="#aaa" marker="aGray"/>
        ))}

        {/* Step 1 content */}
        <rect x={10} y={66} width={168} height={140} rx={4} fill="#fff" stroke={BORDER}/>
        <text x={94} y={84} textAnchor="middle" fontSize="11" fill={BLUE} fontWeight="700">phi_d(s)</text>
        <text x={14} y={100} fontSize="10" fill="#444">From specs: %OS, ts, wn</text>
        <text x={14} y={114} fontSize="10" fill="#444">Specs to: zeta, sigma, omega_n</text>
        <text x={14} y={132} fontSize="10" fill={BLUE} fontFamily="'Courier New',monospace">phi_d(s) = (s-s1)(s-s2)...(s-sn)</text>
        <text x={14} y={150} fontSize="10" fill="#444">Expand to get:</text>
        <text x={14} y={166} fontSize="10" fill={BLUE} fontFamily="'Courier New',monospace">s^n + a_(n-1)s^(n-1)</text>
        <text x={14} y={180} fontSize="10" fill={BLUE} fontFamily="'Courier New',monospace">  + ... + a_1*s + a_0</text>
        <text x={14} y={196} fontSize="10" fill="#555">Coefficients a_i are the</text>

        {/* Step 2 content */}
        <rect x={186} y={66} width={168} height={140} rx={4} fill="#fff" stroke={BORDER}/>
        <text x={270} y={84} textAnchor="middle" fontSize="11" fill={GREEN} fontWeight="700">Controllability Matrix C</text>
        <text x={190} y={100} fontSize="10" fill="#444">C = [B  AB  A2B  ...  An-1B]</text>
        <text x={190} y={118} fontSize="10" fill="#444">Must have rank(C) = n</text>
        <text x={190} y={136} fontSize="10" fill={GREEN} fontFamily="'Courier New',monospace">For n=2, p=1:</text>
        <text x={190} y={152} fontSize="10" fill={GREEN} fontFamily="'Courier New',monospace">C = [b  Ab]</text>
        <text x={190} y={168} fontSize="10" fill="#444">2x2 matrix (invertible</text>
        <text x={190} y={183} fontSize="10" fill="#444">if system is controllable)</text>
        <text x={190} y={198} fontSize="10" fill={GREEN}>e_n^T = [0 0 ... 1]</text>

        {/* Step 3 content */}
        <rect x={362} y={66} width={168} height={140} rx={4} fill="#fff" stroke={BORDER}/>
        <text x={446} y={84} textAnchor="middle" fontSize="11" fill={PURPLE} fontWeight="700">phi(A) -- Cayley-Hamilton</text>
        <text x={366} y={100} fontSize="10" fill="#444">Substitute matrix A into</text>
        <text x={366} y={114} fontSize="10" fill="#444">the desired char. poly:</text>
        <text x={366} y={132} fontSize="10" fill={PURPLE} fontFamily="'Courier New',monospace">phi(A) = A^n + a_(n-1)*A^(n-1)</text>
        <text x={366} y={148} fontSize="10" fill={PURPLE} fontFamily="'Courier New',monospace">  + ... + a_1*A + a_0*I</text>
        <text x={366} y={166} fontSize="10" fill="#444">This is an nxn matrix.</text>
        <text x={366} y={182} fontSize="10" fill="#444">Note: if A already has the</text>
        <text x={366} y={197} fontSize="10" fill="#444">desired poly, phi(A) = 0.</text>

        {/* Step 4 content */}
        <rect x={538} y={66} width={168} height={140} rx={4} fill="#fff" stroke={BORDER}/>
        <text x={622} y={84} textAnchor="middle" fontSize="11" fill={RED} fontWeight="700">Ackermann's Formula</text>
        <rect x={542} y={90} width={160} height={32} rx={3} fill={LTRED} stroke={RED} strokeWidth="1.5"/>
        <text x={622} y={106} textAnchor="middle" fontSize="12" fill={RED} fontWeight="700" fontFamily="'Courier New',monospace">K = e_n^T * C^(-1) * phi(A)</text>
        <text x={542} y={142} fontSize="10" fill="#444">e_n^T = [0 0 ... 0 1]  (1xn)</text>
        <text x={542} y={157} fontSize="10" fill="#444">C^(-1) = inverse of ctrl matrix</text>
        <text x={542} y={172} fontSize="10" fill="#444">phi(A) = desired poly at A</text>
        <text x={542} y={188} fontSize="10" fill={RED}>Result: K is 1xn row vector</text>
        <text x={542} y={202} fontSize="10" fill="#444">Unique solution for SISO.</text>

        {/* Step 5 content */}
        <rect x={714} y={66} width={172} height={140} rx={4} fill="#fff" stroke={BORDER}/>
        <text x={800} y={84} textAnchor="middle" fontSize="11" fill={ORANGE} fontWeight="700">Verification</text>
        <text x={718} y={100} fontSize="10" fill="#444">Check eig(A - B*K) matches</text>
        <text x={718} y={115} fontSize="10" fill="#444">desired poles exactly.</text>
        <text x={718} y={133} fontSize="10" fill={ORANGE} fontFamily="'Courier New',monospace">Verify:</text>
        <text x={718} y={148} fontSize="10" fill={ORANGE} fontFamily="'Courier New',monospace">det(sI - (A-BK))</text>
        <text x={718} y={163} fontSize="10" fill={ORANGE} fontFamily="'Courier New',monospace">  = phi_d(s) ?</text>
        <text x={718} y={180} fontSize="10" fill="#444">Also check stability:</text>
        <text x={718} y={196} fontSize="10" fill="#444">all Re(eig) &lt; 0</text>

        {/* Worked example banner */}
        <rect x={10} y={218} width={880} height={162} rx={5} fill="#fff" stroke={BORDER}/>
        <text x={450} y={236} textAnchor="middle" fontSize="13" fill={DKRED} fontWeight="700">Worked Example: n=2, desired poles at s=-2+/-j2</text>

        {/* Column layout for example */}
        {[
          {
            x:20, color:BLUE,
            title:'Given System',
            lines:[
              'A = [[0, 1], [0, -1]]',
              'B = [[0], [1]]',
              'Desired: s = -2 +/- j2',
            ],
          },
          {
            x:240, color:GREEN,
            title:'Desired Poly phi_d(s)',
            lines:[
              '(s+2-j2)(s+2+j2)',
              '= s^2 + 4s + 8',
              'Coeffs: a1=4, a0=8',
            ],
          },
          {
            x:460, color:PURPLE,
            title:'phi(A) = A^2 + 4A + 8I',
            lines:[
              'A^2 = [[0,-1],[0,1]]',
              'phi(A) = [[8,3],[0,7]]',
              '(computed step by step)',
            ],
          },
          {
            x:680, color:RED,
            title:'K = e2^T * C^(-1) * phi(A)',
            lines:[
              'C = [[0,1],[1,-1]], det=-1',
              'e2^T*C^(-1) = [1, 0]',
              'K = [1,0]*phi(A) = [8, 3]',
            ],
          },
        ].map(({ x, color, title, lines }) => (
          <g key={x}>
            <rect x={x} y={246} width={208} height={124} rx={3} fill="#fafafa" stroke={color} strokeWidth="1"/>
            <text x={x+8} y={262} fontSize="11" fill={color} fontWeight="700">{title}</text>
            {lines.map((t, i) => (
              <text key={i} x={x+8} y={278+i*18} fontSize="10.5" fill="#333"
                fontFamily="'Courier New',monospace">{t}</text>
            ))}
          </g>
        ))}

        <rect x={10} y={376} width={880} height={4} fill="none"/>
      </svg>
      <div style={S.dCaption}>
        Ackermann's formula K = e_n^T * C^(-1) * phi(A) computes the exact gain vector in one shot. The key ingredients are: (1) the desired characteristic polynomial phi_d(s) derived from performance specs, (2) the controllability matrix C whose inverse exists iff the system is controllable, and (3) the matrix polynomial phi(A) obtained by substituting A into phi_d. The formula is exact for SISO systems; for MIMO, numerical methods are preferred.
      </div>
    </div>
  );
}

// =================================================================
// Diagram 5 -- Bass-Gura / Direct coefficient matching method
// =================================================================
function DiagramBassGura() {
  const W = 900, H = 340;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Bass-Gura Method -- Matching Characteristic Polynomial Coefficients</div>
      <svg viewBox={'0 0 ' + W + ' ' + H} style={{ width:'100%', display:'block' }}>
        <Defs/>

        {/* Main equation area */}
        <rect x={10} y={10} width={880} height={70} rx={4} fill={LTBLU} stroke={BLUE} strokeWidth="1.5"/>
        <text x={450} y={32} textAnchor="middle" fontSize="12" fill={BLUE} fontWeight="700">
          Characteristic polynomial of (A - BK): det(sI - A + BK) = s^n + (a_(n-1)+k_n)s^(n-1) + ... + (a_0+k_1)
        </text>
        <text x={450} y={52} textAnchor="middle" fontSize="11" fill="#444">
          Set this equal to desired poly phi_d(s) = s^n + alpha_(n-1)*s^(n-1) + ... + alpha_0
        </text>
        <text x={450} y={68} textAnchor="middle" fontSize="10" fill={BLUE}>
          Valid directly only when A is already in controllable canonical (companion) form
        </text>

        {/* Two panels */}
        <rect x={10} y={90} width={420} height={240} rx={5} fill="#fff" stroke={BORDER}/>
        <text x={220} y={108} textAnchor="middle" fontSize="13" fill={GREEN} fontWeight="700">When A is in Controllable Canonical Form</text>

        {/* CCF matrices */}
        <text x={20} y={130} fontSize="11" fill={GREEN} fontWeight="700">A_c =</text>
        <rect x={58} y={115} width={180} height={88} rx={3} fill={LTGRN} stroke={GREEN} strokeWidth="1"/>
        {[
          ['0','1','0'],
          ['0','0','1'],
          ['-a0','-a1','-a2'],
        ].map((row, r) => row.map((val, c) => (
          <text key={r+'-'+c} x={68+c*58} y={138+r*24} fontSize="10"
            fill={r===2?GREEN:'#666'} fontFamily="'Courier New',monospace">{val}</text>
        )))}

        <text x={256} y={130} fontSize="11" fill={BLUE} fontWeight="700">B_c =</text>
        <rect x={290} y={115} width={36} height={88} rx={3} fill={LTBLU} stroke={BLUE} strokeWidth="1"/>
        {[['0'],['0'],['1']].map((row, r) => (
          <text key={'b'+r} x={298} y={138+r*24} fontSize="10" fill={BLUE} fontFamily="'Courier New',monospace">{row[0]}</text>
        ))}

        <text x={20} y={230} fontSize="11" fill={RED} fontWeight="700">Then K is simply:</text>
        <rect x={20} y={238} width={390} height={34} rx={3} fill={LTRED} stroke={RED} strokeWidth="1.5"/>
        <text x={215} y={252} textAnchor="middle" fontSize="12" fill={RED} fontWeight="700" fontFamily="'Courier New',monospace">
          K = [alpha_0-a_0, alpha_1-a_1, ..., alpha_(n-1)-a_(n-1)]
        </text>
        <text x={215} y={265} textAnchor="middle" fontSize="9" fill={RED}>
          Each gain = (desired coeff) - (original coeff)
        </text>
        <text x={20} y={296} fontSize="10" fill="#444">This is the simplest possible formula -- just subtract!</text>
        <text x={20} y={312} fontSize="10" fill="#444">Works because CCF exposes coefficients directly.</text>
        <text x={20} y={326} fontSize="10" fill={GREEN} fontWeight="700">MATLAB: K = place(A,B,poles) handles this internally.</text>

        {/* Right panel: general case */}
        <rect x={450} y={90} width={440} height={240} rx={5} fill="#fff" stroke={BORDER}/>
        <text x={670} y={108} textAnchor="middle" fontSize="13" fill={ORANGE} fontWeight="700">General Case -- Transform to CCF First</text>

        {[
          { y:120, color:BLUE,   bg:LTBLU,  step:'1', lines:['Compute controllability matrix C = [B AB ... An-1B]'] },
          { y:158, color:GREEN,  bg:LTGRN,  step:'2', lines:['Form transformation matrix T_w: use coefficients of char. poly of A'] },
          { y:196, color:PURPLE, bg:LTPUR,  step:'3', lines:['Transform: A_bar = T^(-1)*A*T,  B_bar = T^(-1)*B'] },
          { y:234, color:RED,    bg:LTRED,  step:'4', lines:['Apply Bass-Gura to (A_bar, B_bar) to get K_bar'] },
          { y:272, color:ORANGE, bg:LTORG,  step:'5', lines:['Transform back: K = K_bar * T^(-1)  (final gain)'] },
        ].map(({ y, color, bg, step, lines }) => (
          <g key={y}>
            <rect x={458} y={y} width={424} height={34} rx={3} fill={bg} stroke={color} strokeWidth="1"/>
            <circle cx={474} cy={y+17} r={10} fill={color}/>
            <text x={474} y={y+21} textAnchor="middle" fontSize="10" fill="#fff" fontWeight="700">{step}</text>
            <text x={490} y={y+19} fontSize="10" fill="#333">{lines[0]}</text>
          </g>
        ))}

        <text x={458} y={318} fontSize="10" fill="#555">Note: Numerically, MATLAB place() and acker() are preferred</text>
        <text x={458} y={332} fontSize="10" fill="#555">over manual Bass-Gura for order n &gt; 3.</text>
      </svg>
      <div style={S.dCaption}>
        The Bass-Gura method exploits the controllable canonical form (CCF), where the characteristic polynomial coefficients appear directly in the last row of A. When A is already in CCF, the gain is simply the difference between desired and actual polynomial coefficients. For general A, a similarity transformation to CCF is performed first. This method provides insight into why controllability is required -- it is exactly the condition that makes the transformation to CCF possible.
      </div>
    </div>
  );
}

// =================================================================
// Diagram 6 -- Comparison of design methods
// =================================================================
function DiagramMethodComparison() {
  const W = 900, H = 340;

  const methods = [
    {
      name:"Ackermann's Formula",
      color:BLUE, bg:LTBLU,
      formula:'K = e_n^T * C^(-1) * phi(A)',
      pros:['Exact closed-form result','Simple for low-order SISO','Good for hand calculation'],
      cons:['SISO only (scalar K)','Numerically ill-conditioned for n&gt;5','Requires C^(-1)'],
      when:'n &lt;= 4, SISO, manual design',
    },
    {
      name:'Bass-Gura / Coeff Match',
      color:GREEN, bg:LTGRN,
      formula:'K_i = alpha_i - a_i  (in CCF)',
      pros:['Very intuitive formula','Reveals coefficient structure','Shows why CCF matters'],
      cons:['Requires transform to CCF','Intermediate steps add error','SISO only effectively'],
      when:'Teaching / understanding CCF',
    },
    {
      name:'MATLAB place()',
      color:ORANGE, bg:LTORG,
      formula:"K = place(A, B, p)  [Kautsky-Nichols]",
      pros:['Numerically robust','Works for MIMO','Handles repeated poles'],
      cons:['Black box -- less insight','Requires all poles specified','May give large K for far poles'],
      when:'Production code, n &gt; 4, MIMO',
    },
    {
      name:'LQR (Optimal)',
      color:RED, bg:LTRED,
      formula:'K = R^(-1) * B^T * P  (Riccati)',
      pros:['Optimal: minimises J=xQx+uRu','Guaranteed stability margins','Systematic Q/R tuning'],
      cons:['Poles not directly specified','Requires Q&gt;=0, R&gt;0 choices','Solves Riccati equation'],
      when:'Optimal design, robustness critical',
    },
  ];

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Pole Placement Method Comparison</div>
      <svg viewBox={'0 0 ' + W + ' ' + H} style={{ width:'100%', display:'block' }}>
        <Defs/>

        {methods.map(({ name, color, bg, formula, pros, cons, when }, idx) => {
          const x = 10 + idx * 222, w = 214;
          return (
            <g key={idx}>
              <rect x={x} y={10} width={w} height={320} rx={5} fill="#fff" stroke={BORDER}/>
              {/* Header */}
              <rect x={x} y={10} width={w} height={40} rx={5} fill={color} opacity="0.12"/>
              <text x={x+w/2} y={30} textAnchor="middle" fontSize="12" fill={color} fontWeight="700">{name}</text>
              <text x={x+w/2} y={44} textAnchor="middle" fontSize="9" fill={color} fontStyle="italic">{formula}</text>

              {/* Pros */}
              <text x={x+8} y={62} fontSize="10" fill={GREEN} fontWeight="700">[OK] Pros</text>
              {pros.map((p, i) => (
                <text key={'p'+i} x={x+8} y={76+i*16} fontSize="9.5" fill="#333">+ {p}</text>
              ))}

              {/* Cons */}
              <text x={x+8} y={142} fontSize="10" fill={RED} fontWeight="700">[X] Cons</text>
              {cons.map((c, i) => (
                <text key={'c'+i} x={x+8} y={156+i*16} fontSize="9.5" fill="#333">- {c}</text>
              ))}

              {/* When to use */}
              <rect x={x+6} y={228} width={w-12} height={38} rx={3} fill={bg} stroke={color} strokeWidth="1"/>
              <text x={x+12} y={242} fontSize="10" fill={color} fontWeight="700">Use when:</text>
              <text x={x+12} y={256} fontSize="9.5" fill="#444">{when}</text>

              {/* Rating bars */}
              <text x={x+8} y={282} fontSize="9" fill="#888">Speed:</text>
              <rect x={x+56} y={273} width={148} height={8} rx={2} fill="#eee"/>
              <rect x={x+56} y={273} width={[90,60,148,100][idx]} height={8} rx={2} fill={color} opacity="0.7"/>
              <text x={x+8} y={300} fontSize="9" fill="#888">Robustness:</text>
              <rect x={x+76} y={291} width={128} height={8} rx={2} fill="#eee"/>
              <rect x={x+76} y={291} width={[60,50,100,128][idx]} height={8} rx={2} fill={color} opacity="0.7"/>
              <text x={x+8} y={318} fontSize="9" fill="#888">Ease:</text>
              <rect x={x+50} y={309} width={154} height={8} rx={2} fill="#eee"/>
              <rect x={x+50} y={309} width={[148,120,154,80][idx]} height={8} rx={2} fill={color} opacity="0.7"/>
            </g>
          );
        })}
      </svg>
      <div style={S.dCaption}>
        Four methods for computing the state feedback gain K. Ackermann's formula and Bass-Gura are ideal for hand calculation on low-order SISO systems and provide deep insight. MATLAB's place() function (Kautsky-Nichols algorithm) is numerically robust and handles MIMO systems. LQR trades direct pole specification for optimality and guaranteed robustness margins -- it is the preferred method when performance must be balanced against control effort.
      </div>
    </div>
  );
}

// =================================================================
// Diagram 7 -- Pre-filter N and steady-state error
// =================================================================
function DiagramPrefilter() {
  const W = 900, H = 360;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Pre-filter N and Integral Action -- Achieving Zero Steady-State Error</div>
      <svg viewBox={'0 0 ' + W + ' ' + H} style={{ width:'100%', display:'block' }}>
        <Defs/>

        {/* -- LEFT: Without N, without integrator -- */}
        <rect x={10} y={10} width={270} height={340} rx={5} fill="#fff" stroke={BORDER}/>
        <rect x={10} y={10} width={270} height={34} rx={5} fill={RED} opacity="0.1"/>
        <text x={145} y={32} textAnchor="middle" fontSize="12" fill={RED} fontWeight="700">No pre-filter: y_ss != r</text>

        {/* mini block diagram */}
        <Arr x1={20} y1={100} x2={50} y2={100} color={RED} marker="aRed"/>
        <text x={16} y={95} fontSize="11" fill={RED} fontWeight="700">r</text>
        <circle cx={68} cy={100} r={16} fill="#fff" stroke={RED} strokeWidth="1.5"/>
        <text x={68} y={105} textAnchor="middle" fontSize="14" fill={RED} fontWeight="700">+</text>
        <Arr x1={84} y1={100} x2={108} y2={100} color={BLUE} marker="aBlue" lbl="u" lx={96} ly={92}/>
        <Blk x={108} y={82} w={90} h={36} fill={LTBLU} stroke={BLUE} label="Plant" sub="A,B,C"/>
        <Arr x1={198} y1={100} x2={260} y2={100} color={BLUE} marker="aBlue" lbl="y" lx={228} ly={92}/>
        <circle cx={224} cy={100} r={4} fill={BLUE}/>
        <line x1={224} y1={100} x2={224} y2={145} stroke={RED} strokeWidth="1.5"/>
        <Blk x={138} y={138} w={70} h={28} fill={LTRED} stroke={RED} label="-K" fs={10}/>
        <line x1={138} y1={152} x2={68} y2={152} stroke={RED} strokeWidth="1.5"/>
        <Arr x1={68} y1={152} x2={68} y2={116} color={RED} marker="aRed"/>

        {/* Step response without N */}
        <rect x={16} y={180} width={254} height={160} rx={3} fill="#fafafa" stroke="#eee"/>
        <text x={143} y={196} textAnchor="middle" fontSize="10" fill="#888">Step response (r=1)</text>
        {(() => {
          const bx=22, by=200, bw=242, bh=130;
          const pts = Array.from({length:60}, (_,k) => {
            const t = k*5/59;
            const s=0.7, wn=3.0, wd=wn*Math.sqrt(1-s*s);
            const yv = 0.7*(1 - Math.exp(-s*wn*t)*(Math.cos(wd*t)+(s/Math.sqrt(1-s*s))*Math.sin(wd*t)));
            return (bx+(t/5)*bw)+','+(by+bh-yv*bh*0.9);
          });
          return (
            <g>
              <line x1={bx} y1={by+bh-0.7*bh*0.9} x2={bx+bw} y2={by+bh-0.7*bh*0.9}
                stroke={RED} strokeWidth="1" strokeDasharray="4 2" opacity="0.5"/>
              <text x={bx+bw-2} y={by+bh-0.7*bh*0.9-3} textAnchor="end" fontSize="8" fill={RED}>y_ss=0.7</text>
              <line x1={bx} y1={by+bh-1.0*bh*0.9} x2={bx+bw} y2={by+bh-1.0*bh*0.9}
                stroke="#bbb" strokeWidth="1" strokeDasharray="3 3"/>
              <text x={bx+bw-2} y={by+bh-1.0*bh*0.9-3} textAnchor="end" fontSize="8" fill="#888">r=1</text>
              <polyline points={pts.join(' ')} fill="none" stroke={RED} strokeWidth="2"/>
              <text x={bx+bw/2} y={by+bh+14} textAnchor="middle" fontSize="9" fill={RED} fontWeight="700">Steady-state error = 0.3 !</text>
            </g>
          );
        })()}

        {/* -- MIDDLE: with pre-filter N -- */}
        <rect x={300} y={10} width={280} height={340} rx={5} fill="#fff" stroke={BORDER}/>
        <rect x={300} y={10} width={280} height={34} rx={5} fill={GREEN} opacity="0.1"/>
        <text x={440} y={32} textAnchor="middle" fontSize="12" fill={GREEN} fontWeight="700">Pre-filter N: y_ss = r</text>

        <Arr x1={310} y1={100} x2={336} y2={100} color={PURPLE} marker="aPurple" lbl="r" lx={314} ly={92}/>
        <Blk x={336} y={84} w={44} h={32} fill={LTPUR} stroke={PURPLE} label="N" fs={11}/>
        <Arr x1={380} y1={100} x2={404} y2={100} color={PURPLE} marker="aPurple"/>
        <circle cx={422} cy={100} r={16} fill="#fff" stroke={RED} strokeWidth="1.5"/>
        <text x={422} y={105} textAnchor="middle" fontSize="14" fill={RED} fontWeight="700">+</text>
        <Arr x1={438} y1={100} x2={462} y2={100} color={BLUE} marker="aBlue"/>
        <Blk x={462} y={82} w={80} h={36} fill={LTBLU} stroke={BLUE} label="Plant" sub="A,B,C"/>
        <Arr x1={542} y1={100} x2={570} y2={100} color={BLUE} marker="aBlue" lbl="y" lx={556} ly={92}/>
        <circle cx={554} cy={100} r={4} fill={BLUE}/>
        <line x1={554} y1={100} x2={554} y2={145} stroke={RED} strokeWidth="1.5"/>
        <Blk x={470} y={138} w={70} h={28} fill={LTRED} stroke={RED} label="-K" fs={10}/>
        <line x1={470} y1={152} x2={422} y2={152} stroke={RED} strokeWidth="1.5"/>
        <Arr x1={422} y1={152} x2={422} y2={116} color={RED} marker="aRed"/>

        {/* N formula */}
        <rect x={306} y={168} width={268} height={40} rx={3} fill={LTPUR} stroke={PURPLE} strokeWidth="1.5"/>
        <text x={440} y={184} textAnchor="middle" fontSize="11" fill={PURPLE} fontWeight="700" fontFamily="'Courier New',monospace">N = -1 / [C*(A-BK)^(-1)*B]</text>
        <text x={440} y={200} textAnchor="middle" fontSize="9.5" fill="#555">Scalar for SISO; ensures y_ss = r for step input</text>

        {/* Step response with N */}
        <rect x={306} y={216} width={268} height={124} rx={3} fill="#fafafa" stroke="#eee"/>
        <text x={440} y={232} textAnchor="middle" fontSize="10" fill="#888">Step response with N</text>
        {(() => {
          const bx=312, by=236, bw=256, bh=96;
          const pts = Array.from({length:60}, (_,k) => {
            const t = k*5/59;
            const s=0.7, wn=3.0, wd=wn*Math.sqrt(1-s*s);
            const yv = 1.0*(1 - Math.exp(-s*wn*t)*(Math.cos(wd*t)+(s/Math.sqrt(1-s*s))*Math.sin(wd*t)));
            return (bx+(t/5)*bw)+','+(by+bh-yv*bh*0.86);
          });
          return (
            <g>
              <line x1={bx} y1={by+bh-1.0*bh*0.86} x2={bx+bw} y2={by+bh-1.0*bh*0.86}
                stroke="#bbb" strokeWidth="1" strokeDasharray="3 3"/>
              <polyline points={pts.join(' ')} fill="none" stroke={GREEN} strokeWidth="2"/>
              <text x={bx+bw/2} y={by+bh+14} textAnchor="middle" fontSize="9" fill={GREEN} fontWeight="700">y_ss = r = 1 (zero error)</text>
            </g>
          );
        })()}

        {/* -- RIGHT: Integral augmentation -- */}
        <rect x={598} y={10} width={292} height={340} rx={5} fill="#fff" stroke={BORDER}/>
        <rect x={598} y={10} width={292} height={34} rx={5} fill={TEAL} opacity="0.1"/>
        <text x={744} y={32} textAnchor="middle" fontSize="12" fill={TEAL} fontWeight="700">Integral Augmentation: robust y_ss = r</text>

        <text x={606} y={56} fontSize="10" fill="#444">Add integrator state x_I = int(r - y) dt</text>
        <text x={606} y={70} fontSize="10" fill="#444">Augmented state: x_aug = [x ; x_I]</text>
        <text x={606} y={86} fontSize="10" fill={TEAL} fontFamily="'Courier New',monospace">A_aug = [[A, 0]; [-C, 0]]</text>
        <text x={606} y={102} fontSize="10" fill={TEAL} fontFamily="'Courier New',monospace">B_aug = [[B]; [0]]</text>

        {[
          { y:116, bg:LTGRN, bc:GREEN,  lines:['[OK] Advantage 1','Eliminates SS error for step r','Without knowing plant parameters exactly'] },
          { y:170, bg:LTGRN, bc:GREEN,  lines:['[OK] Advantage 2','Robust to constant disturbances','Integral rejects constant input d'] },
          { y:224, bg:LTORG, bc:ORANGE, lines:['Requirement','Augmented (A_aug, B_aug) must be','controllable -- one extra pole to place'] },
          { y:278, bg:LTBLU, bc:BLUE,   lines:['Gain structure','u = -K*x - K_I*x_I','K_I is the integral gain (scalar)'] },
        ].map(({ y, bg, bc, lines }) => (
          <Card key={y} x={604} y={y} w={280} h={50} bg={bg} bc={bc} lines={lines}/>
        ))}
      </svg>
      <div style={S.dCaption}>
        Without correction, state feedback typically produces non-unity DC gain: y_ss = N_dc * r where N_dc is not 1. The pre-filter N = -1/[C(A-BK)^(-1)B] corrects this algebraically but is sensitive to plant model errors. Integral augmentation is more robust: it adds an integrator state that automatically accumulates error and forces y_ss = r regardless of model uncertainty or constant disturbances -- at the cost of one additional pole to place.
      </div>
    </div>
  );
}

// =================================================================
// Diagram 8 -- LQR cost function and Q/R tuning
// =================================================================
function DiagramLQR() {
  const W = 900, H = 370;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>LQR -- Optimal Pole Placement via Quadratic Cost Minimisation</div>
      <svg viewBox={'0 0 ' + W + ' ' + H} style={{ width:'100%', display:'block' }}>
        <Defs/>

        {/* Left: cost function anatomy */}
        <rect x={10} y={10} width={400} height={350} rx={5} fill="#fff" stroke={BORDER}/>
        <text x={210} y={28} textAnchor="middle" fontSize="13" fill={DKRED} fontWeight="700">LQR Cost Function J</text>

        <rect x={20} y={36} width={380} height={50} rx={4} fill={LTRED} stroke={RED} strokeWidth="1.5"/>
        <text x={210} y={58} textAnchor="middle" fontSize="13" fill={RED} fontWeight="700" fontFamily="'Courier New',monospace">J = INT_0^inf (x^T Q x + u^T R u) dt</text>
        <text x={210} y={76} textAnchor="middle" fontSize="10" fill="#555">Minimise over all u(t) subject to x_dot = Ax + Bu</text>

        {[
          { y:96,  color:BLUE,   bg:LTBLU,  label:'Q matrix (n x n, Q &gt;= 0)', desc:'Penalises state deviation x^T*Q*x.  Large Q = punish big x.', tip:'Typically Q = C^T*C or diagonal with state weights.' },
          { y:154, color:ORANGE, bg:LTORG,  label:'R matrix (p x p, R &gt; 0)',   desc:'Penalises control effort u^T*R*u.  Large R = small u.', tip:'Larger R/Q ratio gives more conservative (smaller K).' },
          { y:212, color:GREEN,  bg:LTGRN,  label:'P -- Riccati solution (n x n)', desc:'Satisfies: A^T*P + P*A - P*B*R^(-1)*B^T*P + Q = 0', tip:'Algebraic Riccati Equation (ARE) -- solved numerically.' },
          { y:270, color:PURPLE, bg:LTPUR,  label:'Optimal K = R^(-1) * B^T * P', desc:'Closed-loop A-BK guaranteed stable for any Q&gt;=0, R&gt;0.', tip:'Guaranteed GM &gt;= 6 dB, PM &gt;= 60 deg (SISO, full-state).' },
        ].map(({ y, color, bg, label, desc, tip }) => (
          <g key={y}>
            <rect x={20} y={y} width={380} height={54} rx={3} fill={bg} stroke={color} strokeWidth="1"/>
            <text x={28} y={y+16} fontSize="11" fill={color} fontWeight="700">{label}</text>
            <text x={28} y={y+30} fontSize="9.5" fill="#444">{desc}</text>
            <text x={28} y={y+46} fontSize="9.5" fill={color} fontStyle="italic">{tip}</text>
          </g>
        ))}

        {/* Right: Q/R trade-off chart */}
        <rect x={425} y={10} width={464} height={350} rx={5} fill="#fff" stroke={BORDER}/>
        <text x={657} y={28} textAnchor="middle" fontSize="13" fill={DKRED} fontWeight="700">Q/R Ratio Trade-off -- Speed vs Control Effort</text>

        {(() => {
          const bx=440, by=42, bw=200, bh=200;
          const toX2 = q => bx + Math.log10(q/0.1)/3 * bw;
          const toY2 = r => by + bh - Math.log10(r/0.1)/3 * bh;

          const qs = [0.1,1,10,100];
          const rs = [0.1,1,10,100];

          return (
            <g>
              <rect x={bx} y={by} width={bw} height={bh} rx={3} fill="#fafafa" stroke="#eee"/>

              {/* Grid */}
              {qs.map(q => (
                <line key={'qg'+q} x1={toX2(q)} y1={by} x2={toX2(q)} y2={by+bh} stroke="#f0f0f0" strokeWidth="1"/>
              ))}
              {rs.map(r => (
                <line key={'rg'+r} x1={bx} y1={toY2(r)} x2={bx+bw} y2={toY2(r)} stroke="#f0f0f0" strokeWidth="1"/>
              ))}

              {/* Region labels */}
              <text x={bx+bw*0.15} y={by+bh*0.85} textAnchor="middle" fontSize="9" fill={BLUE} opacity="0.7">Conservative</text>
              <text x={bx+bw*0.15} y={by+bh*0.95} textAnchor="middle" fontSize="8" fill={BLUE} opacity="0.7">(small K, large u allowed)</text>
              <text x={bx+bw*0.85} y={by+bh*0.15} textAnchor="middle" fontSize="9" fill={RED} opacity="0.7">Aggressive</text>
              <text x={bx+bw*0.85} y={by+bh*0.25} textAnchor="middle" fontSize="8" fill={RED} opacity="0.7">(large K, fast response)</text>

              {/* Axes */}
              <line x1={bx} y1={by+bh} x2={bx+bw} y2={by+bh} stroke="#bbb" strokeWidth="1.2"/>
              <line x1={bx} y1={by} x2={bx} y2={by+bh} stroke="#bbb" strokeWidth="1.2"/>
              <text x={bx+bw/2} y={by+bh+18} textAnchor="middle" fontSize="10" fill="#777">log(Q) -- state weight</text>
              <text x={bx-22} y={by+bh/2} textAnchor="middle" fontSize="10" fill="#777"
                transform={'rotate(-90,'+(bx-22)+','+(by+bh/2)+')'}>log(R)</text>

              {/* Contours (iso-performance ellipses) */}
              {[0.5,0.7,0.9,1.1].map((sc, i) => (
                <ellipse key={'iso'+i}
                  cx={bx+bw*0.5} cy={by+bh*0.5}
                  rx={bw*0.15*sc} ry={bh*0.12*sc}
                  fill="none" stroke={[BLUE,GREEN,ORANGE,RED][i]} strokeWidth="1.2"
                  strokeDasharray="4 2" opacity="0.5"/>
              ))}

              {/* Design points */}
              {[
                {q:0.5,r:5,   color:BLUE,   label:'Conservative'},
                {q:5,  r:0.5, color:RED,    label:'Aggressive'},
                {q:1,  r:1,   color:GREEN,  label:'Balanced'},
              ].map(({ q, r, color: c, label }) => (
                <g key={label}>
                  <circle cx={toX2(q)} cy={toY2(r)} r={7} fill={c} opacity="0.85"/>
                  <text x={toX2(q)+10} y={toY2(r)+4} fontSize="9" fill={c} fontWeight="700">{label}</text>
                </g>
              ))}
            </g>
          );
        })()}

        {/* Right-side property cards */}
        {[
          { y:260, bg:LTGRN, bc:GREEN,  lines:['Guaranteed stability','LQR is always stable (full-state)','No need to verify margins separately'] },
          { y:310, bg:LTBLU, bc:BLUE,   lines:["Bryson's Rule (starting point)",'Q_ii = 1/(max x_i)^2  per state','R_jj = 1/(max u_j)^2  per input'] },
        ].map(({ y, bg, bc, lines }) => (
          <Card key={y} x={433} y={y} w={450} h={44} bg={bg} bc={bc} lines={lines}/>
        ))}
      </svg>
      <div style={S.dCaption}>
        LQR transforms pole placement into an optimisation problem: find K that minimises the infinite-horizon cost J = integral(x^T*Q*x + u^T*R*u)dt. Increasing Q relative to R drives poles further left (faster, more aggressive). The solution comes from the Algebraic Riccati Equation and is guaranteed stable with classical robustness margins. LQR is preferred when robustness matters more than hitting exact pole locations.
      </div>
    </div>
  );
}

// =================================================================
// Diagram 9 -- Complete design workflow
// =================================================================
function DiagramWorkflow() {
  const W = 900, H = 420;

  const steps = [
    { x:20,  y:30,  w:180, h:80,  color:BLUE,   bg:LTBLU,
      num:'1', title:'Derive State-Space Model',
      lines:['Write equations of motion','Identify A, B, C, D','Check order n'] },
    { x:240, y:30,  w:180, h:80,  color:GREEN,  bg:LTGRN,
      num:'2', title:'Check Controllability',
      lines:['Compute C = ctrb(A,B)','Verify rank(C) = n','Fail: design cannot proceed'] },
    { x:460, y:30,  w:180, h:80,  color:PURPLE, bg:LTPUR,
      num:'3', title:'Translate Specs -> Poles',
      lines:['%OS -> zeta', 'ts -> sigma = 4/ts', 'Dominant pole location'] },
    { x:680, y:30,  w:200, h:80,  color:ORANGE, bg:LTORG,
      num:'4', title:'Compute K',
      lines:['Ackermann / Bass-Gura','MATLAB: place(A,B,p)','Or LQR if optimal'] },
    { x:20,  y:200, w:180, h:80,  color:RED,    bg:LTRED,
      num:'5', title:'Check Non-Dominant Poles',
      lines:['n-2 extra poles needed','Place 3-5x further left','Minimal effect on response'] },
    { x:240, y:200, w:180, h:80,  color:TEAL,   bg:LTTEAL,
      num:'6', title:'Compute Pre-filter N',
      lines:['N = -1/[C*(A-BK)^(-1)*B]','Ensures y_ss = r','Or use integral augmentation'] },
    { x:460, y:200, w:180, h:80,  color:GREEN,  bg:LTGRN,
      num:'7', title:'Simulate & Verify',
      lines:['Plot step response','Check %OS, ts, tr', 'Verify eig(A-BK) correct'] },
    { x:680, y:200, w:200, h:80,  color:BLUE,   bg:LTBLU,
      num:'8', title:'Robustness Check',
      lines:['Gain/phase margins','Test with parameter variation','Observer needed? (not all x measured)'] },
  ];

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Complete State Feedback Design Workflow</div>
      <svg viewBox={'0 0 ' + W + ' ' + H} style={{ width:'100%', display:'block' }}>
        <Defs/>

        {steps.map(({ x, y, w, h, color, bg, num, title, lines }) => (
          <g key={num}>
            <rect x={x} y={y} width={w} height={h} rx={5} fill="#fff" stroke={BORDER}/>
            <rect x={x} y={y} width={w} height={h} rx={5} fill={color} opacity="0.05"/>
            <circle cx={x+18} cy={y+18} r={13} fill={color}/>
            <text x={x+18} y={y+22} textAnchor="middle" fontSize="12" fill="#fff" fontWeight="700">{num}</text>
            <text x={x+36} y={y+15} fontSize="11" fill={color} fontWeight="700">{title}</text>
            {lines.map((t, i) => (
              <text key={i} x={x+10} y={y+32+i*16} fontSize="9.5" fill="#444">{t}</text>
            ))}
          </g>
        ))}

        {/* Row 1 arrows */}
        {[[200,70],[420,70],[640,70]].map(([x,y], i) => (
          <Arr key={'r1a'+i} x1={x} y1={y} x2={x+40} y2={y} color="#bbb" marker="aGray"/>
        ))}

        {/* Down arrow row 1 -> row 2 */}
        <Arr x1={770} y1={110} x2={770} y2={160} color="#bbb" marker="aGray"/>
        <line x1={770} y1={160} x2={630} y2={160} stroke="#bbb" strokeWidth="1.5"/>
        <Arr x1={630} y1={160} x2={420} y2={160} color="#bbb" marker="aGray"/>

        {/* Row 2 arrows (right to left) */}
        {[[420,240],[200,240]].map(([x,y], i) => (
          <Arr key={'r2a'+i} x1={x} y1={y} x2={x-40} y2={y} color="#bbb" marker="aGray"/>
        ))}
        <Arr x1={640} y1={240} x2={660} y2={240} color="#bbb" marker="aGray"/>

        {/* Iteration arrow: if verify fails, go back */}
        <rect x={380} y={312} width={520} height={98} rx={5} fill="#fff" stroke={BORDER}/>
        <text x={640} y={330} textAnchor="middle" fontSize="12" fill={DKRED} fontWeight="700">Iteration Loop</text>
        <rect x={390} y={338} width={498} height={62} rx={3} fill={LTRED} stroke={RED} strokeWidth="1"/>
        <text x={392} y={354} fontSize="10" fill={RED} fontWeight="700">If step response does not meet specs:</text>
        <text x={392} y={370} fontSize="10" fill="#444">a) Move dominant poles: further left (faster), larger damping angle (less overshoot)</text>
        <text x={392} y={385} fontSize="10" fill="#444">b) Check non-dominant poles are sufficiently far left (3-5x rule)</text>
        <text x={392} y={400} fontSize="10" fill="#444">c) If integral action added, re-check all n+1 pole locations</text>

        {/* MATLAB quick-ref */}
        <rect x={10} y={312} width={358} height={98} rx={5} fill="#fff" stroke={BORDER}/>
        <text x={189} y={330} textAnchor="middle" fontSize="12" fill={DKRED} fontWeight="700">MATLAB Quick Reference</text>
        {[
          "Co = ctrb(A,B);  rank(Co)  % check controllability",
          "K = place(A, B, desired_poles)  % place poles",
          "K = acker(A, B, desired_poles)  % Ackermann",
          "[K,P,e] = lqr(A, B, Q, R)      % LQR",
          "N = -1/(C*inv(A-B*K)*B)        % pre-filter",
          "eig(A - B*K)                   % verify",
        ].map((t, i) => (
          <text key={i} x={16} y={346+i*13} fontSize="9" fill="#333" fontFamily="'Courier New',monospace">{t}</text>
        ))}
      </svg>
      <div style={S.dCaption}>
        The complete design workflow proceeds in 8 steps: model derivation, controllability check, spec-to-pole translation, gain computation, non-dominant pole placement, pre-filter calculation, simulation, and robustness validation. Steps 1-4 are mandatory; steps 5-8 refine the design. If simulation reveals unsatisfactory performance, the pole locations are adjusted and the workflow repeats. In practice, steps 4-7 form a tight iteration loop.
      </div>
    </div>
  );
}

// =================================================================
// Diagram 10 -- Dominant pole specs: from %OS, ts to s-plane location
// =================================================================
function DiagramSpecConversion() {
  const W = 900, H = 340;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Converting Performance Specs to Dominant Pole Locations</div>
      <svg viewBox={'0 0 ' + W + ' ' + H} style={{ width:'100%', display:'block' }}>
        <Defs/>

        {/* Left: spec -> pole conversion table visual */}
        <rect x={10} y={10} width={420} height={320} rx={5} fill="#fff" stroke={BORDER}/>
        <text x={220} y={28} textAnchor="middle" fontSize="13" fill={DKRED} fontWeight="700">Spec -&gt; Pole: Conversion Formulas</text>

        {[
          {
            y:38, color:RED, bg:LTRED,
            spec:'% Overshoot (%OS)',
            formula:'zeta = -ln(%OS/100) / sqrt(pi^2 + ln(%OS/100)^2)',
            examples:['%OS=5%  -> zeta=0.69','%OS=16% -> zeta=0.50','%OS=25% -> zeta=0.40'],
          },
          {
            y:120, color:BLUE, bg:LTBLU,
            spec:'Settling time ts (2% criterion)',
            formula:'sigma = |Re(s*)| = 4 / ts',
            examples:['ts=1s   -> sigma=4.0','ts=2s   -> sigma=2.0','ts=0.5s -> sigma=8.0'],
          },
          {
            y:202, color:GREEN, bg:LTGRN,
            spec:'Natural frequency wn',
            formula:'wn = sigma / zeta = sqrt(sigma^2 + wd^2)',
            examples:['sigma=2, zeta=0.7 -> wn=2.86','wd = wn*sqrt(1-zeta^2)','Pole: s* = -sigma +/- j*wd'],
          },
        ].map(({ y, color, bg, spec, formula, examples }) => (
          <g key={y}>
            <rect x={18} y={y} width={394} height={78} rx={3} fill={bg} stroke={color} strokeWidth="1"/>
            <text x={26} y={y+16} fontSize="11" fill={color} fontWeight="700">{spec}</text>
            <text x={26} y={y+32} fontSize="10" fill="#333" fontFamily="'Courier New',monospace">{formula}</text>
            {examples.map((e, i) => (
              <text key={i} x={26+i*130} y={y+52} fontSize="9.5" fill="#555">{e}</text>
            ))}
            <text x={26} y={y+70} fontSize="9" fill={color} fontStyle="italic">
              {y===38?'Angle from Im-axis = cos^(-1)(zeta)':y===120?'Minimum distance from Im-axis':'Radius from origin'}
            </text>
          </g>
        ))}

        {/* Right: s-plane illustration */}
        <rect x={450} y={10} width={440} height={320} rx={5} fill="#fff" stroke={BORDER}/>
        <text x={670} y={28} textAnchor="middle" fontSize="13" fill={DKRED} fontWeight="700">Desired Region in s-Plane</text>

        {(() => {
          const sx=460, sy=40, sw=420, sh=270;
          const xR=[-6,1], yR=[-3.5,3.5];
          const toX = r => sx + (r-xR[0])/(xR[1]-xR[0])*sw;
          const toY = i => sy + (1-(i-yR[0])/(yR[1]-yR[0]))*sh;
          const ox = toX(0), oy = toY(0);
          const sigma = 2, zeta = 0.7;
          const ang = Math.acos(zeta);
          const wn = sigma/zeta;
          const wd = wn * Math.sqrt(1-zeta*zeta);

          return (
            <g>
              {/* Background */}
              <rect x={sx} y={sy} width={sw} height={sh} rx={3} fill="#fafafa" stroke="#eee"/>
              {/* Unstable */}
              <rect x={ox} y={sy} width={sx+sw-ox} height={sh} fill="#ffebee" opacity="0.3"/>

              {/* Desired region: sigma > 2, angle < acos(0.5) from Im */}
              {/* sigma = 2 vertical line */}
              <line x1={toX(-2)} y1={sy} x2={toX(-2)} y2={sy+sh}
                stroke={BLUE} strokeWidth="1.5" strokeDasharray="5 3" opacity="0.7"/>
              <text x={toX(-2)+3} y={sy+14} fontSize="9" fill={BLUE}>sigma=2</text>

              {/* Damping rays */}
              <line x1={ox} y1={oy} x2={toX(-5*Math.cos(ang))} y2={toY(5*Math.sin(ang))}
                stroke={RED} strokeWidth="1.5" strokeDasharray="5 3" opacity="0.7"/>
              <line x1={ox} y1={oy} x2={toX(-5*Math.cos(ang))} y2={toY(-5*Math.sin(ang))}
                stroke={RED} strokeWidth="1.5" strokeDasharray="5 3" opacity="0.7"/>
              <text x={toX(-3*Math.cos(ang))-8} y={toY(3*Math.sin(ang))-5}
                fontSize="9" fill={RED}>zeta=0.7</text>

              {/* Desired zone shading */}
              <polygon
                points={[
                  toX(-2)+','+sy,
                  toX(-6)+','+sy,
                  toX(-6)+','+(sy+sh),
                  toX(-2)+','+(sy+sh),
                ].join(' ')}
                fill={GREEN} opacity="0.07"/>

              {/* Axes */}
              <line x1={sx} y1={oy} x2={sx+sw} y2={oy} stroke="#ccc" strokeWidth="1.2"/>
              <line x1={ox} y1={sy} x2={ox} y2={sy+sh} stroke={RED} strokeWidth="1.5"
                strokeDasharray="5 3" opacity="0.4"/>

              {/* Dominant pole location */}
              <circle cx={toX(-sigma)} cy={toY(wd)} r={8} fill={RED}/>
              <circle cx={toX(-sigma)} cy={toY(-wd)} r={8} fill={RED}/>
              <text x={toX(-sigma)+10} y={toY(wd)-8} fontSize="9.5" fill={RED} fontWeight="700">
                s* = -{sigma}+j{wd.toFixed(1)}
              </text>
              <text x={toX(-sigma)+10} y={toY(-wd)+16} fontSize="9.5" fill={RED} fontWeight="700">
                s* = -{sigma}-j{wd.toFixed(1)}
              </text>

              {/* wn arc */}
              <path d={'M '+(ox)+','+(oy-toX(wn)+ox)+' A '+(toX(wn)-ox)+','+(toX(wn)-ox)+' 0 0,0 '+toX(-wn)+','+oy}
                fill="none" stroke={PURPLE} strokeWidth="1" strokeDasharray="3 3" opacity="0.5"/>
              <text x={toX(-wn/2)} y={oy-24} fontSize="9" fill={PURPLE}>wn={wn.toFixed(2)}</text>

              {/* Grid labels */}
              {[-4,-3,-2,-1,0].map(v => (
                <text key={'gl'+v} x={toX(v)} y={sy+sh+14} textAnchor="middle" fontSize="9" fill="#bbb">{v}</text>
              ))}
              <text x={sx+sw+4} y={oy+4} fontSize="10" fill="#888">sigma</text>

              {/* Annotations */}
              <rect x={sx+2} y={sy+sh-68} width={190} height={64} rx={3} fill="rgba(255,255,255,0.9)" stroke="#eee"/>
              <text x={sx+8} y={sy+sh-54} fontSize="9.5" fill={BLUE} fontWeight="700">sigma = 4/ts = 4/2 = 2</text>
              <text x={sx+8} y={sy+sh-38} fontSize="9.5" fill={RED} fontWeight="700">zeta = 0.7  (from %OS = 5%)</text>
              <text x={sx+8} y={sy+sh-22} fontSize="9.5" fill={PURPLE} fontWeight="700">wn = sigma/zeta = 2.86</text>
              <text x={sx+8} y={sy+sh-8} fontSize="9.5" fill="#555">wd = wn*sqrt(1-zeta^2) = 2.04</text>
            </g>
          );
        })()}
      </svg>
      <div style={S.dCaption}>
        Performance specifications translate directly into geometric constraints on the s-plane. Settling time ts fixes the minimum distance from the imaginary axis (sigma = 4/ts). Percent overshoot fixes the maximum angle from the imaginary axis (cos^(-1)(zeta)). The intersection of these constraints defines the desired region; the dominant poles are placed anywhere inside it. This example places poles at s = -2 +/- j2.04 satisfying ts = 2s and %OS = 5%.
      </div>
    </div>
  );
}

// =================================================================
// Main
// =================================================================
export default function StateFeedback() {
  return (
    <div style={S.wrapper}>
      <h1 style={S.h1}>State Feedback and Pole Placement</h1>
      <p style={S.p}>
        Once a system is modeled in state-space form, the most direct path to meeting performance specifications is full-state feedback: replacing the open-loop input with u(t) = -Kx(t) + Nr(t). The gain matrix K shifts the closed-loop eigenvalues (poles of A-BK) to any desired locations in the s-plane, provided the system is controllable. This single step simultaneously sets stability, damping, and response speed -- a dramatic improvement over single-loop classical design.
      </p>

      <InfoBox title="Core Ideas at a Glance" items={[
        "Control law: u = -Kx + Nr  --  K is the state feedback gain, N is the pre-filter",
        "Closed-loop dynamics: x_dot = (A-BK)x + BNr  --  poles = eigenvalues of A-BK",
        "Pole placement theorem: if (A,B) is controllable, K can place eigenvalues of A-BK ANYWHERE",
        "Specs to poles: %OS -> zeta -> angle; ts -> sigma = 4/ts; both -> desired s*",
        "Ackermann's formula: K = e_n^T * C^(-1) * phi(A)  (exact, SISO, closed-form)",
        "Bass-Gura: K_i = alpha_i - a_i when A is in controllable canonical form",
        "MATLAB: K = place(A,B,p)  or  K = acker(A,B,p)  or  [K,P,e] = lqr(A,B,Q,R)",
        "Pre-filter: N = -1/[C*(A-BK)^(-1)*B]  ensures y_ss = r for step input",
        "LQR: minimises J = INT(x^T*Q*x + u^T*R*u)dt  --  guaranteed stable with GM &gt;= 6dB, PM &gt;= 60deg",
      ]}/>

      <h2 style={S.h2}>The Closed-Loop Block Diagram</h2>
      <p style={S.p}>
        Full-state feedback connects the state vector x directly back through the gain matrix K to form the control input. Unlike classical output feedback, which uses only the measured output y, state feedback uses all n state variables simultaneously. This additional information allows the designer to control all n closed-loop modes independently. The pre-filter N sits in the forward path before the summing junction and corrects the DC gain without affecting the closed-loop poles.
      </p>
      <DiagramBlockDiagram/>
      <Table2 rows={[
        ["Control law","u(t) = -K*x(t) + N*r(t)\nK: 1xn gain vector (SISO) or pxn matrix (MIMO); N: scalar pre-filter"],
        ["Closed-loop A matrix","A_cl = A - B*K\nAll closed-loop behaviour determined by eigenvalues of A_cl"],
        ["Characteristic polynomial","det(sI - (A-BK)) = desired phi_d(s)\nThis is the equation pole placement solves"],
        ["Why state feedback works","K has n free parameters (for SISO); A-BK has n eigenvalues to place\nOne-to-one correspondence when (A,B) is controllable"],
        ["MIMO pole placement","K is now pxn; more free parameters than eigenvalue constraints\nExtra freedom used for robustness or eigenvector shaping"],
        ["Assumption: full state available","Requires all n states to be measured or estimated\nIf only y is available: need Luenberger observer (separation principle)"],
      ]}/>

      <h2 style={S.h2}>Pole Placement in the s-Plane</h2>
      <p style={S.p}>
        The s-plane provides the visual arena for pole placement design. Every desired performance characteristic -- settling time, overshoot, oscillation frequency -- corresponds to a geometric constraint on the dominant pole location. The designer's task is to find the region in the s-plane that satisfies all specs simultaneously, then choose poles inside that region and compute the K that achieves them.
      </p>
      <DiagramSPlane/>
      <Table2 rows={[
        ["Dominant poles","The 1-2 poles closest to the imaginary axis dominate the transient response\nOther poles must be placed at least 3-5x further left to be truly non-dominant"],
        ["Stability boundary","Imaginary axis Re(s) = 0: poles must stay strictly in LHP\nMargin: how far left the dominant poles are placed"],
        ["Damping angle","Lines from origin at angle cos^(-1)(zeta) from imaginary axis\nzeta = 0.5: 60deg from Im-axis; zeta = 0.707: 45deg"],
        ["Natural frequency wn","Semicircles of radius wn centred at origin\nPoles on same circle have same natural frequency regardless of damping"],
        ["Bandwidth connection","Closed-loop bandwidth approx 1.8*wn (for well-damped 2nd order)\nFaster poles (larger |s|) = wider bandwidth = faster rise time"],
        ["Non-dominant pole rule","Place remaining n-2 poles at sigma > 3-5 * |Re(dominant)|\nEnsures their modes decay 3-5x faster and don't distort the step response"],
      ]}/>

      <h2 style={S.h2}>Step Response vs Pole Location</h2>
      <p style={S.p}>
        The connection between pole location and step response is direct and predictable. Poles far left give fast responses; poles near the imaginary axis give slow or oscillatory responses. Understanding this map is the core skill of pole placement design -- the designer reads off the step response characteristics directly from the s-plane geometry.
      </p>
      <DiagramStepResponse/>
      <Table2 rows={[
        ["Overdamped (all real poles)","No overshoot; monotonic rise; typically slower than critically damped\nAll poles real and negative; no complex components"],
        ["Critically damped","Fastest response without any overshoot\nRepeated real poles at s = -wn (breakaway from real axis)"],
        ["Underdamped (complex poles)","Oscillatory step response; overshoot proportional to e^(-pi*zeta/sqrt(1-zeta^2))\nzeta = 0.7: ~5%; zeta = 0.5: ~16%; zeta = 0.3: ~35%"],
        ["Rise time","tr ~= 1.8/wn  (rough approximation for 2nd order)\nFaster poles (larger wn) give shorter rise time"],
        ["Settling time","ts ~= 4/sigma = 4/|Re(dominant pole)|  (2% criterion)\nFurther left = shorter settling time"],
        ["Peak time","tp = pi/wd = pi/(wn*sqrt(1-zeta^2))\nTime to first overshoot peak"],
      ]}/>

      <h2 style={S.h2}>Ackermann's Formula</h2>
      <p style={S.p}>
        Ackermann's formula provides a closed-form expression for the gain vector K that achieves any desired set of closed-loop poles. It uses the controllability matrix C and the desired characteristic polynomial evaluated at the system matrix A. For SISO systems it gives an exact result in one computation; for higher-order systems it is replaced by numerically robust algorithms.
      </p>
      <DiagramAckermann/>
      <Table2 rows={[
        ["Formula","K = e_n^T * C^(-1) * phi(A)\ne_n^T = [0 0 ... 0 1] (last standard basis vector)"],
        ["phi(A)","Substitute matrix A into desired char. poly phi_d(s)\nphi(A) = A^n + alpha_(n-1)*A^(n-1) + ... + alpha_1*A + alpha_0*I"],
        ["Cayley-Hamilton","phi_current(A) = 0 by Cayley-Hamilton theorem (current char. poly at A)\nphi_desired(A) != 0 unless poles already where we want them"],
        ["Why C^(-1) appears","C encodes the reachability directions in state space\nC^(-1) inverts this to extract the correct gain directions"],
        ["Numerical issues","C^(-1) becomes ill-conditioned when poles are nearly repeated or n is large\nFor n&gt;5, prefer MATLAB place() which uses QR-based algorithms"],
        ["MATLAB acker()","K = acker(A, B, p) implements Ackermann's formula numerically\nEquivalent to manual computation; same ill-conditioning issues for large n"],
      ]}/>

      <h2 style={S.h2}>Bass-Gura Method</h2>
      <p style={S.p}>
        The Bass-Gura method exploits the special structure of the controllable canonical form (CCF). In CCF, the characteristic polynomial coefficients appear directly in the last row of A, so the gain that changes those coefficients is simply the difference between desired and actual values. This makes pole placement visually transparent and directly shows why the controllability matrix must be invertible.
      </p>
      <DiagramBassGura/>
      <Table2 rows={[
        ["Controllable canonical form","A in CCF has companion matrix structure; last row = -(a_0, a_1, ..., a_(n-1))\nChar. poly of A_c: s^n + a_(n-1)*s^(n-1) + ... + a_0"],
        ["Direct gain formula","K = [alpha_0-a_0, alpha_1-a_1, ..., alpha_(n-1)-a_(n-1)]\nDesired poly: s^n + alpha_(n-1)*s^(n-1) + ... + alpha_0"],
        ["General A: transform","T_w = C * [a_(n-1) a_(n-2) ... a_0 1; ... ; 0 ... 0 1; 0 ... 0]\nTransform to CCF, apply Bass-Gura, transform back"],
        ["Connection to controllability","Transformation T_w exists iff C = [B AB ... An-1B] is invertible\nExactly the controllability condition -- beautiful geometric connection"],
        ["When to use","Best for teaching and low-order examples (n=2,3)\nReveals the direct link between char. poly coefficients and K"],
        ["MATLAB place() vs Bass-Gura","place() uses numerically robust eigenvector approach (Kautsky-Nichols)\nFor production code always prefer place(); Bass-Gura for understanding"],
      ]}/>

      <h2 style={S.h2}>Comparison of Design Methods</h2>
      <DiagramMethodComparison/>

      <h2 style={S.h2}>Pre-filter and Integral Action</h2>
      <p style={S.p}>
        State feedback with u = -Kx alone does not generally produce unity DC gain: the step response steady-state value y_ss may not equal the reference r. Two approaches correct this. The pre-filter N multiplies r before the loop and is chosen so y_ss = r exactly. Integral augmentation adds an integrator state that accumulates the error r - y, guaranteeing y_ss = r even if the plant model is imperfect.
      </p>
      <DiagramPrefilter/>
      <Table2 rows={[
        ["DC gain without correction","y_ss = -C*(A-BK)^(-1)*B * r  (for step input r)\nThis equals r only when -C*(A-BK)^(-1)*B = 1 (not generally true)"],
        ["Pre-filter N","N = -1/[C*(A-BK)^(-1)*B]  ensures y_ss = r\nDoes NOT change closed-loop poles; only scales the reference"],
        ["Sensitivity of N","N depends on exact plant matrices A, B, C\nModel errors cause steady-state offset -- fragile to parameter variation"],
        ["Integral augmentation","Adds state x_I = integral(r-y)dt to the system\nAugmented order: n+1; one extra pole must be placed"],
        ["Integral advantage","Rejects constant disturbances d entering the plant\nGuarantees y_ss = r even if B, C have model errors (internal model principle)"],
        ["MIMO reference tracking","For MIMO systems, feedforward matrix N_bar more complex\nOften replaced by integral action on each output channel"],
      ]}/>

      <h2 style={S.h2}>LQR -- Optimal Pole Placement</h2>
      <p style={S.p}>
        Linear Quadratic Regulation transforms the pole placement problem into an optimisation: find K that minimises the infinite-horizon cost J = integral(x^T*Q*x + u^T*R*u)dt. Rather than specifying exact pole locations, the designer specifies the relative importance of state regulation (Q) and control effort (R). The resulting K is guaranteed to be stable and to provide classical gain and phase margins, making LQR a cornerstone of modern robust control design.
      </p>
      <DiagramLQR/>
      <Table2 rows={[
        ["Cost function","J = INT_0^inf (x^T*Q*x + u^T*R*u)dt\nQ penalises state error; R penalises control effort"],
        ["Algebraic Riccati Equation","A^T*P + P*A - P*B*R^(-1)*B^T*P + Q = 0\nUnique positive definite solution P exists if (A,B) stabilisable and (A,sqrt(Q)) detectable"],
        ["Optimal gain","K = R^(-1)*B^T*P\nMinimises J; closed-loop A-BK guaranteed Hurwitz (stable)"],
        ["Guaranteed margins","SISO LQR: GM &gt;= 6 dB (gain can double), PM &gt;= 60 degrees\nHolds for full-state feedback -- most powerful robustness guarantee in control"],
        ["Choosing Q and R","Start with Bryson's rule: Q_ii=1/(max x_i)^2, R_jj=1/(max u_j)^2\nThen tune: increase Q for faster response; increase R for less control effort"],
        ["MATLAB","[K,P,e] = lqr(A,B,Q,R)\ne contains closed-loop eigenvalues; P is the Riccati solution"],
      ]}/>

      <h2 style={S.h2}>Converting Specs to Poles</h2>
      <p style={S.p}>
        The practical starting point for any pole placement design is translating time-domain performance requirements into desired s-plane pole locations. Three specifications -- percent overshoot, settling time, and natural frequency -- each constrain the pole location independently. Their intersection defines the achievable design region.
      </p>
      <DiagramSpecConversion/>
      <Table2 rows={[
        ["% Overshoot to zeta","zeta = -ln(%OS/100) / sqrt(pi^2 + ln^2(%OS/100))\n%OS=5%: zeta=0.69; %OS=10%: zeta=0.59; %OS=20%: zeta=0.46"],
        ["Settling time to sigma","sigma = |Re(s*)| = 4/ts  (2% band criterion)\nts=1s: sigma=4; ts=2s: sigma=2; ts=0.5s: sigma=8"],
        ["Natural frequency wn","wn = sigma/zeta = sqrt(sigma^2 + wd^2)\nwn connects damping and speed: larger wn = faster AND possibly less damped"],
        ["Damped frequency wd","wd = wn*sqrt(1-zeta^2) = |Im(s*)|\nOscillation frequency seen in underdamped step response"],
        ["Dominant pole location","s* = -sigma +/- j*wd\nBoth complex conjugate poles placed at this location"],
        ["Rise time tr","tr ~= 1.8/wn  (2nd-order approximation)\nFaster check: tr ~= (1 + 1.1*zeta + 1.4*zeta^2) / wn"],
      ]}/>

      <h2 style={S.h2}>Complete Design Workflow</h2>
      <p style={S.p}>
        Putting all the pieces together, state feedback design follows a systematic 8-step process. The workflow is iterative: simulation results feed back into revised pole locations until all specifications are met. Understanding each step and its purpose allows the designer to troubleshoot efficiently when the first design attempt misses a specification.
      </p>
      <DiagramWorkflow/>
      <Table2 rows={[
        ["Step 1: Model","Derive A, B, C, D from physical equations or system identification\nVerify open-loop eigenvalues match expected behavior"],
        ["Step 2: Controllability","rank(ctrb(A,B)) must equal n\nIf not: redesign actuator placement or accept limited pole placement"],
        ["Step 3: Specs to poles","Convert %OS, ts, wn to desired s* location\nPlace remaining n-2 poles at 3-5x further sigma"],
        ["Step 4: Compute K","Ackermann / Bass-Gura for hand calc; place() / lqr() for software\nVerify eig(A-B*K) matches desired poles"],
        ["Steps 5-6: N and integral","Compute N = -1/[C*(A-B*K)^(-1)*B] for step tracking\nOr augment with integrator for robust tracking"],
        ["Steps 7-8: Simulate and verify","Plot step response: check %OS, ts, tr vs specs\nCheck gain/phase margins; test with +/-20% parameter variation"],
      ]}/>

      <InfoBox title="Key Formulae Summary" items={[
        "Control law:  u = -K*x + N*r   -->   Closed-loop: x_dot = (A-BK)x + BNr",
        "Ackermann:  K = e_n^T * C^(-1) * phi(A)   where phi = desired char. poly evaluated at A",
        "Bass-Gura (CCF):  K = [alpha_0-a_0, ..., alpha_(n-1)-a_(n-1)]",
        "Pre-filter:  N = -1/[C*(A-BK)^(-1)*B]   (corrects DC gain for step input)",
        "Spec conversions:  zeta = -ln(%OS/100)/sqrt(pi^2+ln^2(%OS/100)); sigma = 4/ts",
        "Dominant poles:  s* = -sigma +/- j*wd   where wd = wn*sqrt(1-zeta^2)",
        "LQR:  K = R^(-1)*B^T*P   where A^T*P + P*A - P*B*R^(-1)*B^T*P + Q = 0",
        "MATLAB:  K=place(A,B,p); K=acker(A,B,p); [K,P,e]=lqr(A,B,Q,R)",
      ]}/>
    </div>
  );
}